module.exports = __webpack_public_path__ + "static/media/jewelry-pendant-white.922cd306.svg";